<div class="dialog-panel dialog-photo-editor">
  <div class="icon-close" [inlineSVG]="'/icons/icon-close.svg'" (click)="closeDialog()"></div>
  <div class="dialog-content">
      <div class="spinner-container p-absolute" *ngIf="loading">
          <mat-spinner class="primary" [diameter]="30"></mat-spinner>
      </div>
      <lib-photo-editor [data]="data" (saveImages)="closeDialog($event)"></lib-photo-editor>
  </div>
</div>
